import { ConditionEntry } from '../types/records'

export function loadDemoConditions(): ConditionEntry[] {
  return [
    {
      id: '1',
      user_id: 'demo-user-id',
      condition_id: 'diabetes-t2',
      severity: 'medium',
      diagnosed_date: '2022-03-15',
      status: 'active',
      notes: 'Managed with diet and medication',
      created_at: '2022-03-15T00:00:00Z',
      updated_at: '2024-01-15T00:00:00Z',
      medical_conditions_db: {
        name: 'Type 2 Diabetes Mellitus',
        category: 'Endocrine',
        icd10_code: 'E11.9',
        description: 'A metabolic disorder characterized by high blood sugar'
      }
    },
    {
      id: '2',
      user_id: 'demo-user-id',
      condition_id: 'hypertension',
      severity: 'low',
      diagnosed_date: '2021-11-20',
      status: 'monitoring',
      notes: 'Controlled with lifestyle changes',
      created_at: '2021-11-20T00:00:00Z',
      updated_at: '2024-01-14T00:00:00Z',
      medical_conditions_db: {
        name: 'Hypertension',
        category: 'Cardiovascular',
        icd10_code: 'I10',
        description: 'Persistently high blood pressure'
      }
    }
  ];
}
